var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "" } },
        [
          _c("span", [_vm._v("Supplier Categories")]),
          _c("v-spacer"),
          _c("v-icon", [_vm._v("mdi-account-network")])
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          loading: _vm.splrCatGetting,
          headers: _vm.headers,
          items: _vm.splrCatList
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }